export enum AuthenticationState {
    NotAuthenticated = 0,
    NeedsPasswordReset = 1,
    TotpChallenge = 2,
    TotpError = 3,
    PasswordAttemptsExceeded = 4,
    Authenticated = 5
}